import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import marketTypes from '@/store/modules/properties/constants';
import BaseModule from '@/store/baseModule';

const attributesObjRef = {
  action_plans: {
    serverSide: true,
    type: '$null',
    values: [
      { id: 'O', name: 'Oui' },
      { id: 'N', name: 'Non' },
    ],
  },
  market_type: {
    ...marketTypes,
    values: marketTypes.values.map((item) => ({ ...item, shortname: item.id })),
  },
  top_p1: {
    serverSide: true,
    values: [
      { id: 'O', name: 'Oui' },
      { id: 'N', name: 'Non' },
    ],
  },
  synthesis: {
    serverSide: true,
    values: [
      { id: 'O', name: 'Oui' },
      { id: 'N', name: 'Non' },
    ],
  },
  alerte_chauff_origin: {
    serverSide: true,
    type: '$null',
    values: [
      { id: 'O', name: 'Oui' },
      { id: 'N', name: 'Non' },
    ],
  },
  alerte_ecs_chauff_origin: {
    serverSide: true,
    type: '$null',
    values: [
      { id: 'O', name: 'Oui' },
      { id: 'N', name: 'Non' },
    ],
  },
  alerte_conso_origin: {
    serverSide: true,
    type: '$null',
    values: [
      { id: 'O', name: 'Oui' },
      { id: 'N', name: 'Non' },
    ],
  },
  alerte_conso_pct_origin: {
    serverSide: true,
    type: '$null',
    values: [
      { id: 'O', name: 'Oui' },
      { id: 'N', name: 'Non' },
    ],
  },
  alerte_ecs_origin: {
    serverSide: true,
    type: '$null',
    values: [
      { id: 'O', name: 'Oui' },
      { id: 'N', name: 'Non' },
    ],
  },
  autres_alertes_origin: {
    serverSide: true,
    type: '$null',
    values: [
      { id: 'O', name: 'Oui' },
      { id: 'N', name: 'Non' },
    ],
  },
  etat_chauffe: {
    serverSide: true,
    values: [
      { id: 'O', name: 'Oui' },
      { id: 'N', name: 'Non' },
    ],
  },
};

function SET_SENSORS_QUALITY(state, sensorsList) {
  let items = state.items.data;
  items = items.map((item) => ({
    ...item,
    sensors: sensorsList.find(
      (sensor) => sensor.property_id === item.property_id
    ),
  }));
  state.items.data = items;
}

function SET_ENERGY_CASES(state, casesList) {
  let items = state.items.data;
  items = items.map((item) => ({
    ...item,
    energy_cases: casesList.find(
      (energy) => energy.property_id === item.property_id
    ),
  }));
  state.items.data = items;
}

export default (serviceAPI) =>
  new BaseModule({
    attributesObjRef,
    defaultSortBy: ['priority'],
    defaultASC: [false],
    searchAttributesArray: ['property_code', 'property_name'],
    serviceAPI,
    customMutations: {
      SET_SENSORS_QUALITY,
      SET_ENERGY_CASES,
    },
    makeQueryParams: makeListRequest({
      useEntities: true,
      customFunc: (AndQueryParams) => {
        AndQueryParams.push({
          priority: { $gt: 0 },
        });
      },
    }),
  });
